/**
 * Pont panier pour les applications tierces (Replo, upsells, etc.).
 *
 * Ces apps ajoutent au panier via leurs propres appels AJAX (/cart/add.js)
 * sans connaitre les evenements du theme : le drawer ne s'ouvrait pas et le
 * compteur restait fige jusqu'au rechargement de la page.
 *
 * Ce script intercepte les mutations panier (fetch + XMLHttpRequest) et
 * rejoue les evenements natifs du theme :
 *   - "cart:refresh" -> re-rendu du drawer + mise a jour des compteurs
 *   - "variant:add"  -> ouverture du drawer (mode panier "drawer" uniquement)
 *
 * Quand la mutation vient du theme lui-meme (son "cart:change" suit toujours
 * ses propres requetes), le pont s'efface pour eviter tout double traitement.
 */
(function () {
  if (window.__almaCartBridge) {
    return;
  }
  window.__almaCartBridge = true;

  var lastThemeCartChange = 0;

  document.addEventListener('cart:change', function () {
    lastThemeCartChange = Date.now();
  });

  /**
   * Filet de securite du panier vide : la branche "item_count === 0" du
   * re-rendu du theme attend une animation (Motion) dont la promesse peut ne
   * jamais se resoudre quand elle est annulee (tiroir encore en cours
   * d'ouverture, re-rendu recent). Resultat observe : panier vide cote
   * serveur mais article toujours affiche. 700 ms apres un cart:change a
   * zero article, si l'etat vide n'est pas rendu, on fait la bascule
   * nous-memes a partir de la section deja bundlee, sans animation.
   * Idempotent : si le theme finit ensuite, il repose le meme contenu.
   */
  document.addEventListener('cart:change', function (event) {
    var cart = event.detail && event.detail.cart;
    if (!cart || cart.item_count !== 0 || !cart.sections) {
      return;
    }
    var sectionHtml = null;
    Object.keys(cart.sections).some(function (key) {
      if (key.indexOf('cart-drawer') !== -1) {
        sectionHtml = cart.sections[key];
        return true;
      }
      return false;
    });
    if (!sectionHtml) {
      return;
    }
    setTimeout(function () {
      var drawer = document.querySelector('cart-drawer');
      if (!drawer || drawer.querySelector('.empty-state')) {
        return; // le theme a fini son travail tout seul
      }
      var doc = new DOMParser().parseFromString(sectionHtml, 'text/html');
      var contenu = doc.querySelector('.cart-drawer');
      if (contenu) {
        drawer.replaceChildren.apply(drawer, Array.prototype.slice.call(contenu.childNodes));
      }
    }, 700);
  });

  /**
   * Les cadeaux EIRA restent supprimables individuellement. En revanche, si
   * la ligne parente du bundle est retirée ou descend sous trois flacons, ils
   * ne doivent jamais rester seuls dans le panier et redevenir payants.
   */
  var eiraBundleCleanupInProgress = false;

  document.addEventListener('click', async function (event) {
    var link = event.target.closest && event.target.closest('[data-eira-remove-keys]');
    if (!link) {
      return;
    }

    event.preventDefault();
    var bundleId = link.getAttribute('data-eira-remove-bundle') || '';
    var fallbackKeys = (link.getAttribute('data-eira-remove-keys') || '').split('|').filter(Boolean);
    var updates = {};

    try {
      var cartResponse = await fetch((window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/') + 'cart.js', {
        headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
      });
      var cart = await cartResponse.json();
      cart.items.forEach(function (item) {
        var properties = item.properties || {};
        if ((bundleId && properties._bundle_id === bundleId) || (!bundleId && fallbackKeys.indexOf(item.key) !== -1)) {
          updates[item.key] = 0;
        }
      });

      await fetch((window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/') + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ updates: updates })
      });
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    } catch (error) {
      window.location.href = link.href;
    }
  });

  document.addEventListener('cart:change', async function (event) {
    var cart = event.detail && event.detail.cart;
    if (eiraBundleCleanupInProgress || !cart || !Array.isArray(cart.items)) {
      return;
    }

    var groups = {};
    cart.items.forEach(function (item) {
      var properties = item.properties || {};
      var bundleId = properties._bundle_id;
      if (!bundleId || String(bundleId).indexOf('eira-prime-') !== 0) {
        return;
      }

      var group = groups[bundleId] = groups[bundleId] || {
        parentQuantity: 0,
        giftKeys: []
      };

      if (properties._bundle_item) {
        group.giftKeys.push(item.key);
      } else {
        group.parentQuantity += Number(item.quantity) || 0;
      }
    });

    var updates = {};
    Object.keys(groups).forEach(function (bundleId) {
      var group = groups[bundleId];
      if (group.parentQuantity < 3) {
        group.giftKeys.forEach(function (key) {
          updates[key] = 0;
        });
      }
    });

    if (Object.keys(updates).length === 0) {
      return;
    }

    eiraBundleCleanupInProgress = true;
    try {
      await fetch((window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/') + 'cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({ updates: updates })
      });
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    } catch (error) {
      /* Une prochaine mutation du panier retentera le nettoyage. */
    } finally {
      eiraBundleCleanupInProgress = false;
    }
  });

  function cartMutationPath(url) {
    try {
      var parsed = new URL(url, window.location.origin);
      if (parsed.searchParams.get('eira_offer_builder') === '1') {
        return null;
      }
      var path = parsed.pathname;
      return /\/cart\/(add|change|update|clear)(\.js)?$/.test(path) ? path : null;
    } catch (error) {
      return null;
    }
  }

  function notifyTheme(path) {
    setTimeout(function () {
      if (Date.now() - lastThemeCartChange < 1000) {
        return; // le theme a deja traite sa propre requete
      }
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      var settings = window.themeVariables && window.themeVariables.settings;
      if (path.indexOf('/cart/add') !== -1 && settings && settings.cartType === 'drawer') {
        document.documentElement.dispatchEvent(new CustomEvent('variant:add', { bubbles: true }));
      }
    }, 300);
  }

  var originalFetch = window.fetch;
  window.fetch = function () {
    var input = arguments[0];
    var url = typeof input === 'string' ? input : (input && (input.url || input.href)) || '';
    return originalFetch.apply(this, arguments).then(function (response) {
      if (response && response.ok) {
        var path = cartMutationPath(url);
        if (path) {
          notifyTheme(path);
        }
      }
      return response;
    });
  };

  var originalOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    this.__almaCartPath = cartMutationPath(url || '');
    return originalOpen.apply(this, arguments);
  };

  var originalSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function () {
    var xhr = this;
    if (xhr.__almaCartPath) {
      xhr.addEventListener('load', function () {
        if (xhr.status >= 200 && xhr.status < 300) {
          notifyTheme(xhr.__almaCartPath);
        }
      });
    }
    return originalSend.apply(this, arguments);
  };

  var eiraReservationInterval = null;

  function initEiraReservationTimer() {
    var targets = Array.prototype.slice.call(document.querySelectorAll('[data-eira-cart-reservation]'));
    if (targets.length === 0) {
      return;
    }

    var storageKey = 'eira-cart-reservation-end';
    var now = Date.now();
    var end = 0;
    try {
      end = Number(window.sessionStorage.getItem(storageKey) || 0);
    } catch (error) {
      end = 0;
    }

    if (!end || end <= now) {
      end = now + (10 * 60 * 1000);
      try {
        window.sessionStorage.setItem(storageKey, String(end));
      } catch (error) {
        /* Le minuteur reste fonctionnel meme si le stockage est bloque. */
      }
    }

    if (eiraReservationInterval) {
      window.clearInterval(eiraReservationInterval);
    }

    var tick = function () {
      var remaining = Math.max(0, end - Date.now());
      var minutes = Math.floor(remaining / 60000);
      var seconds = Math.floor((remaining % 60000) / 1000);
      var value = String(minutes).padStart(2, '0') + ':' + String(seconds).padStart(2, '0');
      targets.forEach(function (target) {
        target.textContent = value;
      });

      if (remaining <= 0 && eiraReservationInterval) {
        window.clearInterval(eiraReservationInterval);
        eiraReservationInterval = null;
      }
    };

    tick();
    eiraReservationInterval = window.setInterval(tick, 1000);
  }

  document.addEventListener('cart:change', function () {
    window.setTimeout(initEiraReservationTimer, 150);
  });
  document.documentElement.addEventListener('cart:refresh', function () {
    window.setTimeout(initEiraReservationTimer, 250);
  });
  initEiraReservationTimer();
})();


/* EIRA Offer Builder — retire automatiquement les cadeaux devenus inéligibles. */
(function () {
  if (window.__eiraOfferGiftCleanup) return;
  window.__eiraOfferGiftCleanup = true;

  var busy = false;
  var timer = 0;

  function rootPath() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function giftConfig() {
    var node = document.querySelector('[data-eira-cart-gift-config]');
    return {
      liner: node ? Number(node.getAttribute('data-liner-variant') || 0) : 0,
      oil: node ? Number(node.getAttribute('data-oil-variant') || 0) : 0
    };
  }

  async function clean(cart) {
    if (busy || !cart || !Array.isArray(cart.items)) return;

    var cfg = giftConfig();
    if (!cfg.liner && !cfg.oil) return;

    var maxEligibleQty = 0;
    cart.items.forEach(function (item) {
      var p = item.properties || {};
      if (String(p._eira_offer_builder || '') === '1') {
        maxEligibleQty = Math.max(maxEligibleQty, Number(item.quantity) || 0);
      }
    });

    var updates = {};
    cart.items.forEach(function (item) {
      var variantId = Number(item.variant_id) || 0;
      if (cfg.liner && variantId === cfg.liner && maxEligibleQty < 3) updates[item.key] = 0;
      if (cfg.oil && variantId === cfg.oil && maxEligibleQty < 5) updates[item.key] = 0;
    });

    if (!Object.keys(updates).length) return;

    busy = true;
    try {
      await fetch(rootPath() + 'cart/update.js?eira_offer_builder=1', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ updates: updates })
      });
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    } catch (error) {
      /* Le prochain changement de panier retentera. */
    } finally {
      busy = false;
    }
  }

  function schedule(cart) {
    window.clearTimeout(timer);
    timer = window.setTimeout(async function () {
      if (cart) return clean(cart);
      try {
        var response = await fetch(rootPath() + 'cart.js?eira_offer_builder=1', { headers: { 'Accept': 'application/json' } });
        if (response.ok) clean(await response.json());
      } catch (error) {}
    }, 180);
  }

  document.addEventListener('cart:change', function (event) {
    schedule(event.detail && event.detail.cart);
  });

  document.documentElement.addEventListener('cart:refresh', function () {
    schedule(null);
  });
})();
